export default __webpack_public_path__ + "static/media/04_photo.ea9596ee.jpeg";